import React from "react";
import PropTypes from "prop-types";
import * as commentType from './comments/commentTypes';
import IncidentsComment from "./comments/incidentsComment";
import translate from "react-i18next/dist/commonjs/translate";


class IncidentRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        showComment: false
    };
      this.handleClickComment = this.handleClickComment.bind(this);
      this.ref = React.createRef();
    }

    componentWillMount() {
        if (this.props.selectedIncident != null &&
            this.props.selectedIncident == this.props.id) {
            this.setState({
                showComment: true
            });
        }
    }

    componentDidMount() {
        if (this.state.showComment) {
            this.ref.current.scrollIntoView();
        }
    }

  handleClickComment() {
      this.setState({
          showComment: !this.state.showComment
      });
    }

  render() {
      const {
      addResolutionProposalAction,
      updateCommentType,
      addComment,
      id,
      date,
      priority,
      subject,
      status,
      latestAction,
      comments,
      t
      } = this.props;
      const { showComment } = this.state;

    return (
      <tbody style={{ borderTop: "none" }}>
      <tr onClick={this.handleClickComment} className={`clickable ${showComment ? 'selected' : ''}`}>
                <td><i title={t(`${latestAction}ActionsToTake`)} className={`fa fa-0 ${latestAction === commentType.RESOLUTION_PROPOSAL ? ' comment-priority fa-bell' : (latestAction === commentType.RESOLUTION_PROPOSAL_RECEIVED || latestAction === commentType.RESOLUTION_PROPOSAL_INVESTIGATION) ? ' comment-flagged fa-flag' : 'hide-keep-space'}`} /></td>
          <td>{date}</td>
          <td style={{ fontWeight: "500", color: "#990ae3" }}>{subject}</td>
          <td>{id}</td>
          <td>
            <span className={`incident-label incidentPriority${priority}`}>
              {priority}
            </span>
          </td>
          <td>{ t(status)}</td>
          <td>{t(latestAction)}</td>
          <td>
            {showComment ? (
              <i
                className="fa fa-1 fa-minus-circle"
                style={{ color: "#990ae3" }}
              />
            ) : (
              <i
                className="fa fa-1 fa-plus-circle"
                style={{ color: "#990ae3" }}
              />
            )}
          </td>
            </tr>
            {showComment ? (
                <tr className="table-timeline" ref={this.ref}>
            <td colSpan="8">
              <div>
                <ul className="timeline">
                  {comments.map((comment, index) => {
                    const { Date, User, CommentId, Comment, CommentType } = comment;
                    let isLatest = false;
                    if(index == 0){                      
                        isLatest=true
                      }
                    return (
                      <IncidentsComment
                            isLatest={isLatest}
                            status={status}
                            key={index}
                            date={Date}
                            user={User}
                            commentId={CommentId}
                            comment={Comment}
                            commentType={CommentType}
                            incidentId={id}
                            addResolutionProposalAction={addResolutionProposalAction}
                            updateCommentType={updateCommentType}
                            addComment={addComment}
                            latestAction={latestAction}
                      />
                    );
                  })}
                </ul>
              </div>
            </td>
          </tr>
        ) : null}
      </tbody>
    );
  }
}

IncidentRow.propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  priority: PropTypes.number.isRequired,
  subject: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  latestAction: PropTypes.string.isRequired,
  comments: PropTypes.array,
  latestComment:PropTypes.object,
  selectedIncident: PropTypes.string,
  addResolutionProposalAction: PropTypes.func.isRequired,
  updateCommentType: PropTypes.func.isRequired,
  addComment: PropTypes.func.isRequired
};

export default translate("translations")(IncidentRow);



// WEBPACK FOOTER //
// ./src/incidents/incidentRow.js